// AdminPlaceholderPage — F9.5 WAVE 2E · minimal "Coming soon · WAVE 5" page
// used for admin tools not yet implemented. The route is guarded by
// ProtectedRoute(adminOnly) at the App.js layer.
import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Construction } from "lucide-react";

export default function AdminPlaceholderPage({ title, description, hint }) {
    return (
        <div className="min-h-screen flex items-center justify-center px-6"
             style={{ backgroundColor: "#0A0A0A", color: "#FFFFFF" }}>
            <div className="max-w-md w-full text-center">
                <div className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4"
                     style={{ background: "rgba(255, 255, 255,0.15)" }}>
                    <Construction className="w-8 h-8" style={{ color: "#FFFFFF" }} />
                </div>
                <h1 className="text-2xl font-bold mb-2">{title}</h1>
                {description && (
                    <p className="text-sm text-[#CCCCCC] mb-4">{description}</p>
                )}
                <div className="inline-flex items-center text-xs uppercase tracking-wider font-semibold px-3 py-1 rounded-full mb-6"
                     style={{ backgroundColor: "rgba(255, 255, 255,0.15)", color: "#FFFFFF" }}>
                    Coming soon · WAVE 5
                </div>
                {hint && (
                    <p className="text-xs text-[#999999] mb-6">{hint}</p>
                )}
                <Link
                    to="/admin"
                    className="inline-flex items-center gap-2 text-sm text-white/80 hover:text-white"
                >
                    <ArrowLeft className="w-4 h-4" />
                    Torna al pannello admin
                </Link>
            </div>
        </div>
    );
}
